import React, { memo } from 'react'
import SearchInput from '../../../../../SearchInput/index'
import type { CollectionsTab } from './PlaylistTabContainer'
import { TABS } from './PlaylistTabContainer'

/**
 * Search input + per-tab placeholders.
 *
 * Hidden when the active tab has no rows AND no search term has been typed,
 * so the empty-state CTA isn't fighting the input for vertical space on a
 * genuinely empty / unvisited tab.  Once the user has typed something, the
 * input stays visible even if the search returns zero results — otherwise
 * the box would unmount the moment results went to zero, leaving the user
 * with no way to clear the term.  The `hasRows` derivation lives upstream
 * in the container; this component is purely presentational.
 */

export interface PlaylistTabsSearchBarPlaceholders {
  myPlaylists: string
  following: string
  discover: string
}

export interface PlaylistTabsSearchBarProps {
  collectionsTab: CollectionsTab
  collectionsSearch: string
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSearchSubmit: () => void
  placeholders: PlaylistTabsSearchBarPlaceholders
  hasRows: boolean
}

function PlaylistTabsSearchBarBase ({
  collectionsTab,
  collectionsSearch,
  onSearchChange,
  onSearchSubmit,
  placeholders,
  hasRows,
}: PlaylistTabsSearchBarProps) {
  if (!hasRows && !collectionsSearch) return null
  let placeholder = placeholders.discover
  if (collectionsTab === TABS.MY_PLAYLISTS) placeholder = placeholders.myPlaylists
  else if (collectionsTab === TABS.FOLLOWING) placeholder = placeholders.following
  return (
    <SearchInput
      value={collectionsSearch || ''}
      onChange={onSearchChange}
      placeholder={placeholder}
      onSubmit={collectionsTab === TABS.DISCOVER ? onSearchSubmit : undefined}
      className="playlist-tab-container__search"
    >
    </SearchInput>
  )
}

const PlaylistTabsSearchBar = memo(PlaylistTabsSearchBarBase)
PlaylistTabsSearchBar.displayName = 'PlaylistTabsSearchBar'
export default PlaylistTabsSearchBar
